import { createStore } from 'vuex'

export default createStore({
  state: {
    baseUrl: "https://cms.teammisfit.pl"
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
